/**
 * Seleção por intervalo na view atual da lista de pedidos (Shift+clique).
 * Marca todos os ids entre fromId e toId (inclusive), unindo à seleção atual.
 */
export function selectIdRange(visibleIds, fromId, toId, currentSelected = []) {
  const from = visibleIds.indexOf(fromId);
  const to = visibleIds.indexOf(toId);
  if (from < 0 || to < 0) {
    if (toId == null) return [...currentSelected];
    return currentSelected.includes(toId)
      ? [...currentSelected]
      : [...currentSelected, toId];
  }
  const start = Math.min(from, to);
  const end = Math.max(from, to);
  const range = visibleIds.slice(start, end + 1);
  const next = new Set(currentSelected);
  for (const id of range) next.add(id);
  return Array.from(next);
}

export function toggleId(currentSelected = [], id) {
  if (id == null) return [...currentSelected];
  return currentSelected.includes(id)
    ? currentSelected.filter((item) => item !== id)
    : [...currentSelected, id];
}
